import React, { useState } from "react"
import { EditUserFormTextField } from "./EditUserFormTextField"

interface User {
  id: number
  first_name: string
}

interface FirstNameFieldProps {
  user: User
}

export const FirstNameField: React.FC<FirstNameFieldProps> = ({ user }) => {
  const [value, setValue] = useState(user.first_name || "")

  const fieldData = {
    field: "first_name",
    name: "first_name",
    label: "First Name",
    placeholder: "Enter your real first name",
    required: true,
  }

  return (
    <>
      <EditUserFormTextField
        fieldData={fieldData}
        value={value}
        setValue={setValue}
        userId={user.id}
      />
    </>
  )
}
